<div class="structure-node-selection" [formGroup]="strcutureSelectionFormGroup">

    <mat-form-field class="structure-node-selection-field" appearance="fill">
        <mat-label>
            <sc-dictionary-label dictionaryKey="shared.structure-node-selection.label"></sc-dictionary-label>
        </mat-label>
        <mat-select name="structureNode" formControlName="structureNode">
            <mat-option *ngFor="let o of structureNodes" [value]="o">
                <ng-container *ngIf="o.stationGroupId == null && o.stationSetId != null">
                    &nbsp;&nbsp;
                </ng-container>
                {{o.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
